<!--列表查看视图-->
<template>
  <div>
    <div style="width: fit-content">
      <div style="display: flex; height: 700px">
        <div class="section form-column">
          <el-form label-width="112px" style="height:100%">
            <el-form-item label="MBL">
              <el-input v-model="mblNo" no="1" :disabled="true" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.TransportationClause')">
              <el-input
                :disabled="true"
                :value="job.freightTerm"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.MasterBLFreightTerm')">
              <cargo-advance-select
                no="paymentTermMBL"
                :disabled="true"
                :select-type="selectTypeNames.basic_data_PaymentTerm"
                filterable
                :clearable="false"
                :default-value="job.paymentTermMBL"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.TradeTerms2')">
              <cargo-advance-select
                no="incoTerm"
                :disabled="true"
                :select-type="selectTypeNames.basic_data_IncoTerm"
                filterable
                :clearable="false"
                :default-value="job.incoTerm"
                @parentCallBack="p=>{job.incoTerm=p.value}"
              />
            </el-form-item>
            <booking-sea-eq-data-grid
              v-if="job.containerLoadType==='FCL'||job.containerLoadType==='BB'||job.containerLoadType==='BCF'||job.containerLoadType==='BC'"
              ref="bookingSeaEqDataGrid"
              no="bookingSeaEqDataGrid"
              :value="seaEqList"
              :is-edit="false"
              :container-load-type="job.containerLoadType"
              :job="job"
            />
          </el-form>
        </div>
        <div class="section form-column" style="width: 350px;">
          <el-form label-width="112px" label-position="right" style="height:100%" :disabled="true">
            <el-form-item>
              <span slot="label" class="blue">{{ $t('SeaExport.PortOfLoading') }}</span>
              <div style="display: flex; justify-content: space-between">
                <cargo-advance-select
                  ref="loadingPortCode"
                  no="loadingPortCode"
                  :select-type="selectTypeNames.basic_data_Seaport"
                  filterable
                  :default-value="job.loadingPortCode"
                  tag-name="englishName"
                  style="flex:1"
                />&nbsp;
                <el-checkbox v-model="job.transfering" no="transfering" style="padding-left:2px;">{{ $t('SeaExport.Transit') }}</el-checkbox>
              </div>
            </el-form-item>
            <el-form-item
              v-show="job.transfering"
              :label="$t('SeaExport.TransitPort')"
            >
              <cargo-advance-select
                no="transferPortCode"
                :select-type="selectTypeNames.basic_data_Seaport"
                filterable
                :default-value="job.transferPortCode"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('SeaExport.PortOfDischarge') }}</span>
              <cargo-advance-select
                no="dischargingPortCode"
                :select-type="selectTypeNames.basic_data_Seaport"
                filterable
                :default-value="job.dischargingPortCode"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('SeaExport.PlaceOfDelivery') }}</span>
              <cargo-advance-select
                no="destinationPortCode"
                class="port-of-delivery-selector"
                popper-class="port-of-delivery-selector-popper"
                :select-type="selectTypeNames.basic_data_Seaport"
                filterable
                :default-value="job.destinationPortCode"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label">{{ $t('CargoMsg.Cargo_PlaceOfDeliveryRegion') }}</span>
              <cargo-advance-select
                no="placeOfDeliveryRegion"
                :select-type="selectTypeNames.basic_data_Region"
                filterable
                :default-value="job.placeOfDeliveryRegion"
                @parentCallBack="p=>{job.placeOfDeliveryRegion=p.value}"
              />
            </el-form-item>
            <el-form-item
              :label="$t('SeaExport.PlaceOfReceiptOnBl')"
            >
              <cargo-advance-select
                :disabled="true"
                :select-type="selectTypeNames.basic_data_Seaport"
                filterable
                :default-value="form.dispatchingPlaceCode||''"
                tag-name="englishName"
              />
              <el-input v-model="form.dispatchingPlace" no="52" />
            </el-form-item>
            <el-form-item
              :label="$t('SeaExport.PortOfLoadingOnBl')"
            >
              <cargo-advance-select
                :disabled="true"
                :select-type="selectTypeNames.basic_data_Seaport"
                filterable
                :default-value="form.loadingPortCode||''"
                tag-name="englishName"
                no="loadingPortCode"
              />
              <el-input v-model="form.loadingPort" no="53" />
            </el-form-item>
            <el-form-item
              :label="$t('SeaExport.PortOfDischargeOnBl')"
            >
              <cargo-advance-select
                :disabled="true"
                :select-type="selectTypeNames.basic_data_Seaport"
                filterable
                :default-value="form.dischargingPortCode||''"
                tag-name="englishName"
                no="dischargingPortCode"
              />
              <el-input v-model="form.dischargingPort" no="54" />
            </el-form-item>
            <el-form-item
              :label="$t('SeaExport.PlaceOfDeliveryOnBl')"
            >
              <cargo-advance-select
                :disabled="true"
                :select-type="selectTypeNames.basic_data_Seaport"
                filterable
                :default-value="form.destinationPortCode||''"
                tag-name="englishName"
                no="destinationPortCode"
              />
              <el-input v-model="form.destinationPort" no="55" />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('SeaExport.DateOfDeparture2') }}</span>
              <div style="display: flex">
                <el-date-picker
                  no="etd"
                  class="departure-date-picker"
                  :value="job.etd"
                  :picker-options="{
                    disabledDate: disabledDate
                  }"
                  type="date"
                  value-format="yyyy-MM-dd"
                  style="flex: 1;margin-right: 5px"
                />
              </div>
            </el-form-item>
            <el-form-item>
              <span slot="label">{{ $t('SeaExport.DateOfArrival2') }}</span>
              <div style="display: flex">
                <el-date-picker
                  v-model="job.eta"
                  no="eta"
                  :picker-options="{
                    disabledDate: disabledDate
                  }"
                  style="flex: 1;margin-right: 5px"
                  type="date"
                  value-format="yyyy-MM-dd"
                />
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Vessel')">
              <cargo-advance-select
                no="5"
                :select-type="selectTypeNames.static_data_Vessel"
                :cache="false"
                filterable
                :default-value="job.vessel"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Voyage')">
              <cargo-advance-select
                ref="voyageFlight"
                no="6"
                :cache="false"
                :default-value="job.voyageFlight"
                filterable
                clearable
                tag-name="voyageNo"
                tag-value="voyageNo"
                :filter-tag-names="['voyageNo']"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ShippingCompanyContractNo')">
              <el-input v-model="job.scNo" no="10" />
            </el-form-item>
            <el-form-item label="CNPT No.">
              <cargo-repeat-value-select
                v-model="job.cNptNo"
                :placeholder="''"
                no="cNptNo"
                filterable
                :allow-create="true"
                clearable
                :options="cNptList"
                label-field="no"
                value-field="no"
                unique-field="no"
                :match-of-repeat-value="matchOfCNpt"
                @change="cNptChangeHandler"
                @handleBlur="cNptBlurHandler"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_CarrierCode')">
              <el-input v-model="job.carrierCode" no="carrierCode" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_userDefinedRole1')">
              <cargo-user-select
                ref="userDefinedRoleId1"
                no="userDefinedRoleId1"
                :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole1'}"
                :default-value="job.userDefinedRoleId1||''"
                :merge-load="true"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_userDefinedRole2')">
              <cargo-user-select
                ref="userDefinedRoleId2"
                no="userDefinedRoleId2"
                :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole2'}"
                :default-value="job.userDefinedRoleId2||''"
                :merge-load="true"
              />
            </el-form-item>
          </el-form>
        </div>
        <div class="section form-column" style="width: 350px;">
          <el-form label-width="112px" label-position="right" style="height:100%" :disabled="true">

            <el-form-item :label="$t('SeaExport.BlType')">
              <el-select
                v-model="form.releaseType"
                no="62"
              >
                <el-option
                  v-for="(item,index) in blModeList"
                  :key="index"
                  :label="item.name"
                  :value="item.serialNumber"
                />
              </el-select>
            </el-form-item>
            <el-form-item
              :label="$t('SeaExport.NumberOfPackagesOnBl')"
            >
              <auto-number-input
                v-model="form.quantity"
                no="31"
                :precision="0"
                :min="0"
              />
            </el-form-item>

            <el-form-item
              :label="$t('SeaExport.Weight')"
            >
              <div class="form-item-input">
                <el-input-number
                  v-model="form.weight"
                  no="36"
                  :precision="3"
                  :min="0"
                  :controls="false"
                  style="flex:1"
                />
                <span>KGS</span>
              </div>
            </el-form-item>
            <el-form-item
              :label="$t('SeaExport.Cubage')"
            >
              <div class="form-item-input">
                <el-input-number
                  v-model="form.cubage"
                  no="37"
                  :precision="3"
                  :min="0"
                  :controls="false"
                  style="flex:1"
                />
                <span>CBM</span>
              </div>
            </el-form-item>

            <el-form-item
              :label="$t('SeaExport.Package')"
            >
              <cargo-packing-select
                no="32"
                :default-value="form.packing"
              />
            </el-form-item>
            <el-form-item
              class="auto-width"
              :label="$t('SeaExport.EnglishDescriptionOfGoods')"
            >
              <special-character-tip :texts="specialCharCheck.cargoEnglishName">
                <cargo-rich-textarea
                  ref="cargoTextarea1"
                  v-model="form.cargoEnglishName"
                  no="43"
                  :text-chars="englishNameMaxChars"
                  :warning-count="englishNameWarningCount"
                  wrap-symbol="r"
                  :disabled="true"
                  auto-uppercase
                  auto-half-word
                  style="height: 110px"
                  @dblclick.native="showAdvanceTextDialog($t('SeaExport.EnglishDescriptionOfGoods'),form.cargoEnglishName,val=>{form.cargoEnglishName=val},false,null,true , {
                    warningCount: englishNameWarningCount, maxChar: englishNameMaxChars,autoUppercase:true,autoHalfWord:true
                  })"
                />
              </special-character-tip>
            </el-form-item>
            <el-form-item
              class="auto-width"
              :label="$t('SeaExport.Marks')"
            >
              <special-character-tip :texts="specialCharCheck.mark">
                <cargo-rich-textarea
                  ref="cargoTextarea2"
                  v-model="form.mark"
                  no="48"
                  :text-chars="markMaxChars"
                  :warning-count="markWarningCount"
                  wrap-symbol="r"
                  :disabled="true"
                  auto-uppercase
                  auto-half-word
                  style="height: 110px"
                  @dblclick.native="showAdvanceTextDialog($t('SeaExport.Marks'),form.mark,val=>{form.mark=val},false,null,true , {
                    warningCount: markWarningCount, maxChar: markMaxChars,autoUppercase:true,autoHalfWord:true
                  })"
                />
              </special-character-tip>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.HsCode')">
              <el-input
                v-model="hsCode"
                no="hsCode"
                type="textarea"
                :rows="5"
                @input="val=>{}"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.HsCode'),hsCode,val=>{})"
              />
            </el-form-item>

            <el-form-item :label="$t('SeaExport.BlRemarks')">
              <el-input
                v-model="form.remarks"
                no="remarks"
                type="textarea"
                :rows="4"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.Remarks'),form.remarks,val=>{form.remarks=val})"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PortOfLoadingPOR')">
              <el-input v-model="job.bargePOL" no="71" />
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div
        class="section"
        style="width:100%"
      >
        <div class="form-row" style="display:flex;flex-direction:row;margin-top:8px">
          <el-form
            label-width="50px"
            label-position="left"
            style="margin-right:10px"
          >
            <el-form-item
              :label="$t('SeaExport.Shipper')"
            >
              <cargo-input v-model="form.shipperCode" :disabled="true" no="shipperCode" style="width:115px;margin-right: 5px" :placeholder="$t('SeaExport.ShipperId')" :auto-uppercase="true" />
              <cargo-company-select
                :disabled="true"
                no="shipperId"
                :method-params="{shipper:true,active:true}"
                :default-value="form.shipperId||''"
                style="display: inline-block;width:145px;"
              />
            </el-form-item>
            <el-form-item
              v-for="i in 7"
              :key="i"
              label-width="0"
            >
              <special-character-tip :texts="specialCharCheck['shipperLine'+i]">
                <cargo-input
                  :ref="'shipperLine'+i"
                  v-model="form['shipperLine'+i]"
                  :no="'shipperLine'+i"
                  :disabled="true"
                  :auto-uppercase="true"
                  :use-read-only="true"
                  @change="()=>wrapAddr(form,'shipperLine'+i,i+1 > 7 ? null :'shipperLine'+(i+1),maxChars)"
                  @dblclick.native="showAdvanceTextDialog($t('SeaExport.Shipper'),mergeShipperLine(),splitShipperLine,true,{autoHalfWord:true,autoUppercase:true,maxChar:maxChars,warningCount: warningCount})"
                />
              </special-character-tip>
            </el-form-item>
          </el-form>
          <el-form
            label-width="65px"
            label-position="left"
            style="margin-right:20px"
          >
            <el-form-item
              :label="$t('SeaExport.Consignee')"
            >
              <cargo-input v-model="form.consigneeCode" :disabled="true" no="consigneeCode" style="width:115px;margin-right: 5px" :placeholder="$t('SeaExport.ConsigneeId')" :auto-uppercase="true" />
              <cargo-company-select
                :disabled="true"
                no="consigneeId"
                :method-params="{consignee:true,active:true}"
                :default-value="form.consigneeId||''"
                style="display: inline-block;width:145px;"
              />
            </el-form-item>
            <el-form-item
              v-for="i in 7"
              :key="i"
              label-width="0"
            >
              <special-character-tip :texts="specialCharCheck['consigneeLine'+i]">
                <cargo-input
                  :ref="'consigneeLine'+i"
                  v-model="form['consigneeLine'+i]"
                  :no="'consigneeLine'+i"
                  :disabled="true"
                  :auto-uppercase="true"
                  :use-read-only="true"
                  @change="()=>wrapAddr(form,'consigneeLine'+i,i+1 > 7 ? null :'consigneeLine'+(i+1),maxChars)"
                  @dblclick.native="showAdvanceTextDialog($t('SeaExport.Consignee'),mergeConsigneeLine(),splitConsigneeLine,true,{autoHalfWord:true,autoUppercase:true,maxChar:maxChars,warningCount: warningCount})"
                />
              </special-character-tip>
            </el-form-item>
          </el-form>
          <el-form
            label-width="50px"
            label-position="left"
            style="margin-right:20px"
          >
            <el-form-item
              :label="$t('SeaExport.NotifyParty')"
            >
              <cargo-input v-model="form.notifyCode" no="notifyCode" :disabled="true" style="width:115px;margin-right: 5px" :placeholder="$t('SeaExport.NotifyId')" :auto-uppercase="true" />
              <cargo-company-select
                no="notifyId"
                :disabled="true"
                :method-params="{notify:true,active:true}"
                :default-value="form.notifyId||''"
                style="display: inline-block;width:145px;"
              />
            </el-form-item>
            <el-form-item
              v-for="i in 7"
              :key="i"
              label-width="0"
            >
              <special-character-tip :texts="specialCharCheck['notifyLine'+i]">
                <cargo-input
                  :ref="'notifyLine'+i"
                  v-model="form['notifyLine'+i]"
                  :no="'notifyLine'+i"
                  :disabled="true"
                  :auto-uppercase="true"
                  :use-read-only="true"
                  @change="()=>wrapAddr(form,'notifyLine'+i,i+1 > 7 ? null :'notifyLine'+(i+1),maxChars)"
                  @dblclick.native="showAdvanceTextDialog($t('SeaExport.NotifyParty'),mergeNotifyLine(),splitNotifyLine,true,{autoHalfWord:true,autoUppercase:true,maxChar:maxChars,warningCount: warningCount})"
                />
              </special-character-tip>
            </el-form-item>
          </el-form>
        </div>
      </div>

      <div style="display:flex;flex-direction:column">
        <cargo-ag-grid
          no="51"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="ediContainerFinalRowData"
          style="width:100%;height:350px"
          @gridReady="params=>{gridApi=params.api}"
        />
      </div>
    </div>

    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      append-to-body
      no="advanceTextDialog"
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="closeAdvanceText"
    >
      <cargo-rich-textarea
        ref="advanceTextDialogTextarea"
        v-model="advanceTextDialog.value"
        no="advanceTextDialogTextarea"
        :disabled="true"
        :text-chars="advanceTextDialog.formatObj.maxChar"
        :warning-count="advanceTextDialog.formatObj.warningCount"
        :auto-half-word="advanceTextDialog.formatObj.autoHalfWord"
        :auto-uppercase="advanceTextDialog.formatObj.autoUppercase"
        style="height: 320px;"
      />
      <span slot="footer">
        <el-button
          v-show="isEdit"
          no="advanceTextDialogConfirm"
          type="primary"
          @click="finishAdvanceText"
        >{{ $t('common.btn.confirm') }}</el-button>
        <el-button
          no="advanceTextDialogClose"
          @click="advanceTextDialog.visible=false;closeAdvanceText()"
        >{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import bookingSeaEqDataGrid from '@/components/Cargo/Job/bookingSeaEqDataGrid'
import cargoInput from '@/components/Cargo/Common/cargoInput'
import specialCharacterTip from '@/components/Cargo/Common/specialCharacterTip'
import cargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea'
import { CargoDocUtil } from '@/class/cargo/model/utils/CargoDocUtil'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { getCNptFunc } from '@/api/company'
import cargoRepeatValueSelect from '@/components/Cargo/Common/cargoRepeatValueSelect'
import AutoNumberInput from '@/components/Cargo/Common/AutoNumberInput'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import { SeaCargoDoc } from '@/class/model/booking/SeaCargoDoc'
import cargoPackingSelect from '@/components/Cargo/Common/cargoPackingSelect'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { getSpecificBasicData } from '@/utils/basicDataCache'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor'
import ColumnUtils from '@/utils/ColumnUtils'
import { formatNumberToThousands } from '@/utils'
import { cacheName, cache } from '@/utils/cacheManager'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import StrUtils from '@/utils/StrUtils'
import { queryEdiContainerDataFunc } from '@/api/seaExport/seaCargoDoc'

export default {
  name: 'EdiMblWindow',
  components: {
    cargoAdvanceSelect,
    bookingSeaEqDataGrid,
    cargoInput,
    specialCharacterTip,
    cargoRepeatValueSelect,
    cargoRichTextarea,
    cargoUserSelect,
    cargoCompanySelect,
    cargoPackingSelect,
    AutoNumberInput
  },
  props: {
    context: { type: Object, required: true },
    action: { type: String, required: true, default: 'look' }
  },
  data() {
    return {
      loading: false,
      selectTypeNames: TYPE_NAMES,
      job: new SeaExportJob().fillDefaultValue().getData(),
      form: new SeaCargoDoc().fillDefaultValue().getData(),
      seaEqList: [],
      showMarkOrCargoEnglishNameDialog: false, // 英文品名唛头是否双击展示
      advanceTextDialog: {
        visible: false,
        title: '',
        value: '',
        successCallback: null,
        isUppercase: false,
        formatObj: {
          warningCount: -1,
          maxChar: 0,
          autoHalfWord: false,
          autoUppercase: false
        }
      },
      blModeList: [
        { serialNumber: 1, code: 'ORIGINAL', name: 'ORIGINAL', localName: this.$t('SeaExport.OriginalNormal') },
        { serialNumber: 2, code: 'SURRENDERED', name: 'SURRENDERED', localName: this.$t('SeaExport.TelexRelease') },
        { serialNumber: 3, code: 'SEA WAYBILL', name: 'SEA WAYBILL', localName: this.$t('SeaExport.TelexRelease') }
      ],
      mblNo: '',
      hsCode: '',
      warningCount: 35,
      maxChars: 34,
      englishNameMaxChars: 0,
      markMaxChars: 0,
      englishNameWarningCount: 200,
      markWarningCount: 0,
      specialCharCheck: {
        cargoEnglishName: null,
        mark: null,
        shipperLine1: null,
        shipperLine2: null,
        shipperLine3: null,
        shipperLine4: null,
        shipperLine5: null,
        shipperLine6: null,
        shipperLine7: null,
        consigneeLine1: null,
        consigneeLine2: null,
        consigneeLine3: null,
        consigneeLine4: null,
        consigneeLine5: null,
        consigneeLine6: null,
        consigneeLine7: null,
        notifyLine1: null,
        notifyLine2: null,
        notifyLine3: null,
        notifyLine4: null,
        notifyLine5: null,
        notifyLine6: null,
        notifyLine7: null
      },
      JobUtils,
      cNptList: [],
      matchOfCNpt: options => {
        const option = options.find(p => p.no === this.job.cNptNo)
        return option || options[0]
      },
      gridApi: null,
      rowData: [],
      gridOptions: {
        rowSelection: 'multiple',
        singleClickEdit: true,
        suppressCellSelection: true,
        rowHeight: 32,
        frameworkComponents: {
          CargoAgGridCommonInputEditor
        },
        context: {
          componentParent: this
        }
      }
    }
  },
  computed: {
    ediContainerFinalRowData() {
      return this.rowData.filter(p => !p.deleted)
    },
    isEdit() {
      return this.action !== 'look' && (!this.form.uuid || this.form.state < 2)
    },
    columnDefs() {
      return [
        {
          headerName: '',
          field: '',
          width: 40,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        }, {
          headerName: this.$t('SeaExport.ContainerSize'),
          field: 'eqSize',
          width: 160
        }, {
          headerName: this.$t('SeaExport.ContainerType'),
          field: 'eqType',
          width: 160
        }, {
          headerName: this.$t('SeaExport.ContainerNo'),
          field: 'containerNo',
          width: 160
        }, {
          headerName: this.$t('SeaExport.SealNo'),
          field: 'sealNo',
          width: 160
        }, {
          headerName: this.$t('SeaExport.Quantity'),
          colId: 'quantity',
          field: 'quantity',
          width: 160,
          valueFormatter: params => formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 0, true)),
          editable: this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              precision: 0
            }
          },
          onCellValueChanged: p => this.packageInfoChanged(p)
        },
        {
          headerName: this.$t('SeaExport.Weight'),
          colId: 'weight',
          field: 'weight',
          width: 160,
          valueFormatter: params => formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 3, true)),
          editable: this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              precision: 3
            }
          },
          onCellValueChanged: p => this.packageInfoChanged(p)
        },
        {
          headerName: this.$t('SeaExport.Cubage'),
          colId: 'cubage',
          field: 'cubage',
          width: 160,
          valueFormatter: params => formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 3, true)),
          editable: this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              precision: 3
            }
          },
          onCellValueChanged: p => this.packageInfoChanged(p)
        },
        {
          headerName: 'NCM No.',
          field: 'ncmNo',
          colId: 'ncmNo',
          minWidth: 250,
          tooltipValueGetter: (params) => {
            return params.value
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_WoodenPackagingType'),
          field: 'woodenPackagingType',
          colId: 'woodenPackagingType',
          minWidth: 250,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_WoodenPackageType, 'code', params.value, 'name')
          },
          tooltipValueGetter: (params) => {
            return params.value + ' [' + ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_WoodenPackageType, 'code', params.value, 'name') + ']'
          }
        }
      ]
    },
    config() {
      return this.context.config
    }
  },
  created() {
  },
  methods: {
    async onShow(job, form) {
      await this.init()
      this.job = job
      this.form = form
      this.seaEqList = job.seaEQ = job.seaEQ || []

      if (job.customerId) {
        await getCNptFunc(job.customerId).then(res => {
          this.cNptList = res.data
        })
      }
      getSpecificBasicData(basicCacheKeys.basic_data_BlMode).then(data => {
        for (const item of data) {
          if (item.blType === 1) {
            this.blModeList.push(item)
          }
        }
      })
      if (form.docType === CargoDocConsts.MBL || form.docType === CargoDocConsts.HBL) {
        this.mblNo = job.mbl
        this.rowData = job.containers
      } else {
        this.mblNo = this.form.mblNbr2
        this.rowData = [... await queryEdiContainerDataFunc({ cargoDocUuid: this.form.uuid }).then(res => res.data)]
      }
      // if (form.docType === CargoDocConsts.MBL) {
      //   this.hsCode = job.hsCode
      // } else {
      //   this.hsCode = form.hsCode
      // }
      // PILL-1056 发送eBK和eSI页面使用的HS CODE，改为使用MBL页签的HS CODE。
      this.hsCode = form.hsCode
    },
    async init() {
      await cache.load(cacheName.CONFIG)
      this.maxChars = Number(this.config.get('SEShipperConsigneNotifyMaxchars')) || 45
      this.warningCount = Number(this.config.get('SEShipperConsigneNotifyWarningColor')) || 35
      // 从配置中读取英文品名最大字符数
      const maxChars = Number(this.config.get('SEEnglishDescriptionOfGoodsMaxchars'))
      if (maxChars > 0) {
        this.englishNameMaxChars = maxChars
      }
      // 从配置中读取唛头最大字符数
      const maxChars2 = Number(this.config.get('SEMarkMaxChars'))
      if (maxChars2 > 0) {
        this.markMaxChars = maxChars2
      }
      // 从配置中读取海运出口MBL英文品名标红字符数
      const maxColor = Number(this.config.get('SEEnglishDescriptionOfGoodWarningColor'))
      if (maxColor > 0) {
        this.englishNameWarningCount = maxColor
      }
      // 从配置中读取海运出口MBL唛头标红字符数
      const maxColor2 = Number(this.config.get('SEMarkWarningColor'))
      if (maxColor2 > 0) {
        this.markWarningCount = maxColor2
      }
      if (Number(this.config.get('SpecialCharacterCheck')) === 1) {
        for (const key in this.specialCharCheck) {
          this.specialCharCheck[key] = StrUtils.getSpecialTexts(this.form[key])
        }
      } else {
        for (const key in this.specialCharCheck) {
          this.specialCharCheck[key] = null
        }
      }
    },
    closeAdvanceText() {
      this.showMarkOrCargoEnglishNameDialog = false
    },
    finishAdvanceText() {
      const successCallback = this.advanceTextDialog.successCallback
      if (successCallback && typeof successCallback === 'function') {
        successCallback(this.advanceTextDialog.value)
      }
      this.advanceTextDialog.visible = false
    },
    // 是否可选择一年以外的时间点
    disabledDate(time) {
      const startDate = new Date()
      startDate.setFullYear(startDate.getFullYear() - 1)
      const endDate = new Date()
      endDate.setFullYear(endDate.getFullYear() + 1)
      return (time.getTime() < startDate.getTime() || time.getTime() > endDate.getTime())
    },
    mergeShipperLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        result += this.form['shipperLine' + i] || ''
        result += '\n'
      }
      result += (this.form['shipperLine7'] || '')
      return result.trimEnd()
    },
    splitShipperLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.form['shipperLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.form['shipperLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.form['shipperLine' + i] = ''
      }
    },
    mergeConsigneeLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        result += this.form['consigneeLine' + i] || ''
        result += '\n'
      }
      result += (this.form['consigneeLine7'] || '')
      return result.trimEnd()
    },
    splitConsigneeLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.form['consigneeLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.form['consigneeLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.job['consigneeLine' + i] = ''
      }
    },
    mergeNotifyLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        result += this.form['notifyLine' + i] || ''
        result += '\n'
      }
      result += (this.form['notifyLine7'] || '')
      return result.trimEnd()
    },
    splitNotifyLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.form['notifyLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.form['notifyLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.job['notifyLine' + i] = ''
      }
    },
    wrapAddr(source, from, to, maxChars) {
      CargoDocUtil.sftAddrInputWrap.call(this, source, from, to, maxChars)
    },
    showAdvanceTextDialog(title, value, successCallback, isUppercase = false, formatObject = null) {
      this.advanceTextDialog.title = title
      this.advanceTextDialog.value = value
      this.advanceTextDialog.successCallback = successCallback
      this.advanceTextDialog.isUppercase = isUppercase
      const defaultFormatObj = {
        warningCount: -1,
        maxChar: 0,
        autoHalfWord: false,
        autoUppercase: false
      }
      this.advanceTextDialog.formatObj = formatObject ? { ...defaultFormatObj, ...formatObject } : defaultFormatObj
      this.advanceTextDialog.visible = true
      if (title === this.$t('SeaExport.EnglishDescriptionOfGoods') || title === this.$t('SeaExport.Marks')) {
        this.showMarkOrCargoEnglishNameDialog = true
      }
      this.$nextTick(() => {
        this.$refs.advanceTextDialogTextarea.editor.focus()
      })
    },
    cNptChangeHandler(value, option) {
      this.job.cNptName = ''
      if (option) {
        this.job.cNptNo = option.no
        this.job.cNptName = option.companyName
      }
    },
    cNptBlurHandler(value) {
      this.job.cNptName = ''
      if (value) {
        const cNpt = this.cNptList.find(item => item.no === value)
        if (cNpt) {
          this.job.cNptNo = cNpt.no
          this.job.cNptName = cNpt.companyName
        } else {
          this.job.cNptNo = value
        }
      }
    }
  }
}
</script>

<style lang="scss">
</style>
